module.exports = "https://static.cdns.space/qurangrowth-temp/img/p1.20eb780e.webp";